// Sugalarm — /api/carbs wrappers (cycle 102, voice carb lookup).
//
// `POST /api/carbs/estimate` is a **Fly** endpoint (the kiosk-allowed
// text-only carb estimator), so this goes through `apiClient` with the
// device token — NOT the loopback agent client. Only the transcribed
// food text is sent; the audio stays on the Pi (Leopard transcribes
// locally). The response shape is identical to the photo estimator.

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";
import type { PhotoEstimate } from "./photo";

// Same shape as the photo estimator (server reuses `PhotoEstimateOut`).
export type CarbEstimate = PhotoEstimate;

export function estimateCarbs(
  description: string,
): Promise<ApiResult<CarbEstimate>> {
  return request<CarbEstimate>("/api/carbs/estimate", {
    method: "POST",
    body: { description },
  });
}
